<template>
  <div class="hzc-industry-dynamics">
    <div>当前位置：<span @click="back" style="cursor: pointer">苯酐</span> > 萘系减水剂</div>
    <div class="content">
      <div class="header">
        <em></em>
        <p>萘系减水剂</p>
        <div class="btn fr" @click="search">搜索</div>
        <input class="fr" type="text" v-model="likeTitleName" placeholder="请输入关键词">
      </div>
      <div class="tabs">
        <div @click="changeTabs('issue_anhydride_water_price')" :class="{'hover':flag === 'issue_anhydride_water_price'}">
          价格
        </div>
        <div @click="changeTabs('issue_anhydride_water_exit')"
             :class="{'hover':flag === 'issue_anhydride_water_exit'}">进出口
        </div>
      </div>
      <ul>
        <li v-for="(item,index) in list" :key="index">
          <img src="../../../assets/home/liebiaoqian.png" alt="">
          <p @click="goDetail(item.completeOriginalDate)">{{
              item.date + (flag === 'issue_anhydride_water_price' ? '萘系减水剂价格' : '萘系减水剂进出口')
            }}</p>
          <span class="fr">{{ item.completeOriginalDate }}</span>
          <em v-if="(index+1)%5 === 0 && (index+1) !== list.length" class="xiaxuxian"></em>
        </li>
      </ul>
    </div>
    <div style="text-align: center;">
      <span
          style="vertical-align:middle;display: inline-block;width: 50px;height: 32px;text-align: center;line-height: 32px;background-color: rgb(244, 244, 245);font-weight: normal;cursor: pointer;"
          @click="goFirst">首页</span>
      <el-pagination
          style="margin: 24px 0;display: inline-block;vertical-align:middle;"
          background
          prev-text="上一页"
          next-text="下一页"
          :page-size="size"
          :current-page="page"
          @current-change="changePage"
          layout="prev, pager, next,slot, total,jumper"
          :total="total">
        <span
            style="margin-right:10px;display: inline-block;width: 50px;height: 32px;text-align: center;line-height: 32px;background-color: rgb(244, 244, 245);font-weight: normal;cursor: pointer;"
            @click="goLast">末页</span>
      </el-pagination>
      <span
          style="margin-left:20px;color:#FFF;background-color:#D3131A;margin-right:10px;display: inline-block;width: 50px;height: 32px;text-align: center;line-height: 32px;font-weight: normal;cursor: pointer;">跳转</span>
    </div>
  </div>
</template>

<script>
import {
  cutWaterList,
} from '@/api/anhydride'

export default {
  data() {
    return {
      list: [],
      total: 0,
      flag: 'issue_anhydride_water_price',
      page: 1,
      size: 15,
      likeTitleName: ''
    }
  },
  created() {
    if (this.$route.query && this.$route.query['flag']) {
      this.flag = this.$route.query['flag'];
    }
    this.getList();
  },
  methods: {
    // 列表
    getList() {
      cutWaterList({
        pageNum: this.page,
        pageSize: this.size,
        likeTitleName: this.likeTitleName,
        dictDataType: this.flag
      }).then(res => {
        this.list = res.rows;
        this.total = res.total;
      })
    },
    /**
     * 搜索
     */
    search() {
      this.getList()
    },
    /**
     * 切换tabs
     */
    changeTabs(num) {
      this.flag = num;
      this.page = 1;
      this.getList();
    },
    /**
     * 前往详情页
     */
    goDetail(id) {
      this.$router.push({path: `/anhydride/cutWater`, query: {id, flag: this.flag}})
    },
    /**
     * 回退
     */
    back() {
      this.$router.push('/anhydride')
    },
    /**
     * 分页
     */
    goFirst() {
      this.page = 1;
      this.getList()
    },
    goLast() {
      this.page = Math.ceil(this.total / 15);
      this.getList()
    },
    changePage(page) {
      this.page = page;
      this.getList()
    },
  }
}
</script>

<style scoped lang="less">
@import "../../../style/twoPage";
</style>
